<script lang="ts" setup>
// Imports
import { NakedImage } from 'vue-datocms';
import Icon from '~/components/elements/Icon.vue';

// Types
import { type DownloadItemFragment } from '#gql/default';

// Props
const props = defineProps<{
  data: DownloadItemFragment;
}>();

// Methods
const getFile = (document: DownloadItemFragment['document']) => {
  if (document) {
    const fileType = getFileType(document.filename);
    const fileSize = getFileSize(document.size);
    return `${fileType} - ${fileSize}`;
  }
};

const getFileSize = (size: number) => {
  if (size < 1000) {
    return `${size} B`;
  } else if (size < 1000000) {
    return `${(size / 1000).toFixed()} KB`;
  } else if (size < 1000000000) {
    return `${(size / 1000000).toFixed()} MB`;
  }
};

const getFileType = (type: string) => {
  return type.split('.')[1].toUpperCase();
};
</script>

<template>
  <a
    v-if="data.document"
    class="download-item"
    :href="data.document.url"
    target="_blank"
  >
    <NakedImage
      v-if="data.thumbnail?.responsiveImage"
      :data="data.thumbnail.responsiveImage"
      picture-class="thumbnail _hidden-vs"
      image-class="image"
    />
    <div class="container">
      <h2 class="title text-md">{{ data.title }}</h2>
      <span class="text-xs">
        {{ getFile(data.document) }}
      </span>
    </div>
    <Icon custom-class="icon" type="download" />
  </a>
</template>

<style scoped lang="scss">
.download-item {
  display: flex;
  background-color: var(--base-color-white-80);
  border-radius: 0.5rem;
  text-decoration: none;

  @media (--vs) {
    // flex-direction: column-reverse;
    gap: 1rem;
    padding: 1rem 2.5rem 1rem 2rem;
  }

  @media (--vl) {
    align-items: center;
    gap: 1.5rem;
    padding: 1.5rem 2.5rem 1.5rem 1.5rem;
  }
}

.download-item > .thumbnail {
  border-radius: 0.15rem;
  background-color: lightblue;
  overflow: hidden;
}

.download-item > .thumbnail > .image {
  max-width: 6.25rem;
  width: 100%;
}

.download-item > .container {
  display: flex;
  flex-direction: column;

  @media (--vl) {
    gap: 0.5rem;
  }
}

// Move the icon to the right
.download-item > :deep(.icon) {
  margin-left: auto;

  @media (--vs) {
    width: 1.5rem;
  }
  @media (--vl) {
    width: 2.5rem;
  }
}
</style>
